import { Reveal, SectionHeading } from "../components/Reveal";
import NetworkViz from "../components/NetworkViz";

export default function ProblemaSection() {
  return (
    <section id="problema" className="section" data-testid="problema-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="Il problema"
          title={<>IL PROBLEMA NON È LA CASA. <span className="gold-text">È TUTTO QUELLO CHE SUCCEDE INTORNO.</span></>}
        />
        <Reveal delay={0.1} className="mt-14">
          <NetworkViz
            center="CLIENTE"
            testidPrefix="problema"
            nodes={["AGENTE", "TECNICO", "ARCHITETTO", "IMPRESA", "BANCA · NOTAIO", "DOCUMENTI · SCADENZE"]}
          />
        </Reveal>
        <div className="mt-10 grid gap-6 md:grid-cols-[1.4fr_1fr] md:gap-16">
          <Reveal delay={0.15}>
            <p className="text-[17px] leading-[1.75] text-[#929292]" data-testid="problema-copy">
              Quando ogni parte del percorso viene gestita separatamente, la complessità e i rischi ricadono
              sempre sul cliente: telefonate perse, informazioni frammentate, decisioni prese sotto pressione.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="font-serif text-[24px] leading-snug text-cream sm:text-[28px]" data-testid="problema-closing">
              A.C. HUB nasce per cambiare tutto questo.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
